// extracted by mini-css-extract-plugin
export var editButton = "_qx-0";